module.exports = __webpack_public_path__ + "static/media/logo_ara.60429953.png";